import module from '../module';
import * as _ from 'lodash';

function InputElementErrorDirectiveLink($scope, element, attributes, $ngForm) {
    $ngForm.highlightAllErrors = $ngForm.highlightAllErrors || function () {
            _.each(this, function (field, name) {
                if (name && name[0] != '$' && field && field.$setTouched) {
                    field.$setTouched();
                }
            });
        };
    $ngForm.hideAllErrors = $ngForm.hideAllErrors || function () {
            _.each(this, function (field, name) {
                if (name && name[0] != '$' && field && field.$setUntouched) {
                    field.$setUntouched();
                }
            });
        };
}

module.directive('inputError', function () {
    return {
        template: "<div class='errors' ng-messages='messages.$error' ng-show='messages.$touched && messages.$invalid' ng-transclude='' layout='column'></div>",
        transclude: true,
        replace: false,
        scope: {
            messages: '='
        },
        require: '^form',
        link: InputElementErrorDirectiveLink
    };
});


// WEBPACK FOOTER //
// ./src/modules/shared/directives/InputElementErrorDirective.js